module.exports = __webpack_public_path__ + "img/face-grin-beam.b5813e08.svg";